import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';

import { ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';
import type { TOrder, TOrderItem } from '@shared/models';
import { OrdersService } from '@shared/services';
import { MyCurrencyPipe } from '@shared/pipes';

@Component({
    'selector': 'app-order',
    'templateUrl': './order.page.html',
    'styleUrls': ['./order.page.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MyCurrencyPipe
    ]
})
export class OrderPage extends ViewBasePage implements OnInit, OnDestroy {
    public order: TOrder = {
        billing: {},
        header: {
            total: 0,
            totalFormatted: ''
        },
        items: [],
        shipping: {}
    };
    public purchasedItems: TOrderItem[] = [];
    private uid = '';

    constructor(private ordersService: OrdersService, private activatedRoute: ActivatedRoute, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_ORDER);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        try {
            const uid = this.activatedRoute.snapshot.paramMap.get('uid');
            if (uid) {
                this.uxHelperService.showSpinner();
                this.order = await this.ordersService.getByUid(uid);

                this.initMoreMenu();
                this.uxHelperService.hideSpinner();
            }
        } catch (err) {
            this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        // this.pushPopoverMenuItem('Show Tour', 'show-order-tour');
    }

    public getGrandTotalFormatted() {
        const value = this.order?.header?.total;
        if (value) {
            const valueFormatted = this.utilsService.formatAsCurrency(value);
            return valueFormatted;
        } else {
            return '$0.00';
        }
    }

    public getDescription() {
        const value = this.order?.header?.description;
        if (value) {
            return value;
        } else {
            return '';
        }
    }

    public getNote() {
        const value = this.order?.header?.notes;
        if (value) {
            return value;
        } else {
            return '';
        }
    }

    public getItemTotalFormatted(item: TOrderItem) {
        const value = item.total;
        if (value) {
            const valueFormatted = this.utilsService.formatAsCurrency(value);
            return valueFormatted;
        } else {
            return '$0.00';
        }
    }

    public getTaxFormatted(item: TOrderItem) {
        const value = item.tax;
        if (value) {
            const valueFormatted = this.utilsService.formatAsCurrency(value);
            return valueFormatted;
        } else {
            return '$0.00';
        }
    }

    public getSubtotalFormatted(item: TOrderItem) {
        const value = item.subtotal;
        if (value) {
            const valueFormatted = this.utilsService.formatAsCurrency(value);
            return valueFormatted;
        } else {
            return '$0.00';
        }
    }

    public getUnitPriceFormatted(item: TOrderItem) {
        const value = item.unitPrice;
        if (value) {
            const valueFormatted = this.utilsService.formatAsCurrency(value);
            return valueFormatted;
        } else {
            return '$0.00';
        }
    }

    public getOrderId() {
        const value = this.order.header.orderId;
        if (value) {
            return value;
        } else {
            return '';
        }
    }

    public getCreatedDate() {
        const dateStr = this.order.header.createdDate?.date;
        if (dateStr) {
            const dateTs = this.dateService.formatTimestamp(dateStr, Constants.DateTimeFormats.Full);
            return dateTs;
        } else {
            return '';
        }
    }
    //    public onShowOrderClick() {
    // //        this.order.header.createdDateFormatted = this.utilsService.formatTimeStamp(this.order.header.createdDate);
    //         this.order.header.totalFormatted = this.utilsService.formatAsCurrency(this.order.header.total);
    //         this.order.items.forEach((item) => {
    //             item.unitPriceFormatted = this.utilsService.formatAsCurrency(item.price);
    //             item.taxFormatted       = this.utilsService.formatAsCurrency(item.tax);
    //             item.subtotalFormatted  = this.utilsService.formatAsCurrency(item.subtotal);
    //             item.totalFormatted     = this.utilsService.formatAsCurrency(item.total);
    //         });
    //    }
}
